import { type SearchEntry } from '@ctn/ui/types/ctn-filter-bar';
import { yupResolver } from '@hookform/resolvers/yup';
import { type Resolver } from 'react-hook-form';
import * as yup from 'yup';

import { PAGE_SIZE } from '@/constants/table.constants';

export const PAYLOAD_PAGINATION = {
	start: 0,
	limit: PAGE_SIZE.OPERACIONES,
};

export const payloadDefault = ({listaIdsEstados}: {listaIdsEstados: number[]}) => ({
	...PAYLOAD_PAGINATION,
	listaIdsEstados
});

export type FilterFormData = {
    	tipoBusqueda: string;
    	busqueda: string;
    	idTipoSubsanacion: string;
	search?: SearchEntry[];
};
    
export const getSchema = (): Resolver<FilterFormData> => {
	const schema = yup.object().shape({
		tipoBusqueda: yup.string(),
		busqueda: yup.string(),
		idTipoSubsanacion:  yup.string(),
	});
	return yupResolver(schema) as Resolver<FilterFormData>;
};
    
export const defaultValues = {
	tipoBusqueda: 'numeroTramite',
	busqueda: '',
	idTipoSubsanacion: '',
	search: [],
};